import { Component, Vue } from 'vue-property-decorator';
import { ArticleTextModuleViewModel } from '@/modules/ArticleTextModule/ArticleTextModule.types';
import { getArticleCta } from './ArticleText.utils';

const ArticleTextProps = Vue.extend(ArticleTextModuleViewModel);

@Component({
  components: {},
})
export default class ArticleText extends ArticleTextProps {
  get TextData() {
    const { NewsletterSingUpCta, Text: ArticleTextRaw } = this.p

    const ArticleTextCleaned = ArticleTextRaw?.replace(/<p>&nbsp;<\/p>/g, '')
    const ArticleTextImg = ArticleTextCleaned?.replace(/.aspx"/g, '.aspx?quality=50&maxwidth=1920&format=jpg" style="height:auto"')
    const ArticleText = ArticleTextImg?.replace(/.pdf"/g, `.pdf" title="PDF download"`)

    if (!NewsletterSingUpCta) return ArticleText
    const { ButtonStyle, Target, Link, Text, Title } = this.p.NewsletterSingUpCta.Button

    return getArticleCta(
      { ButtonStyle, Target, Link, Text, Title },
      ArticleText,
      this.$parent.$attrs.contentLinkId,
    )
  }
}
